module.exports = "/img/item-5.6e0cfb4d.png";